<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  .hotlistEventEngagement {
    align-items: center;
    display: flex;
    @extend .text-body-3;

    .bullet {
      font-size: 70%;
      margin: 0 0.25rem;
    }

    .campaignLink {
      font-size: 0.75rem !important; // !important is needed to override the <a> style from Dashboard
      color: $primary-color;
      &:hover {
        color: $dark-blue;
      }
    }
  }
</style>

<script>
  export let event;
  const MAPPING = {
    click: {
      prefix: "clicked",
      missingCampaign: "emails",
      suffix: "multiples times",
    },
    open: {
      prefix: "opened",
      missingCampaign: "emails",
      suffix: "multiple times",
    },
    openOldEmail: {
      prefix: "opened",
      missingCampaign: "an email",
      suffix: "sent over 30 days ago",
    },
  };
  $: mapObj = MAPPING[event.reason];
</script>

<div class="hotlistEventEngagement">
  {#if event.engagements}
    <span class="bullet">&bullet;</span>
    {mapObj.prefix}
    {#if event.campaignName}
      <a
        class="campaignLink"
        href="/campaign?campaignId={event.campaignId}"
        target="blank_"
        >&nbsp;{event.campaignName.length > 30
          ? `${event.campaignName.slice(0, 30)}...`
          : event.campaignName}&nbsp;</a
      >
    {:else}
      {mapObj.missingCampaign}
    {/if}
    {mapObj.suffix}
    {#if event.reason !== "openOldEmail"}
      (engaged {event.engagements} time{event.engagements > 1 ? "s" : ""})
    {/if}
  {/if}
</div>
